export default __webpack_public_path__ + "static/media/logo.a87228ba.png";